import { api } from '@/lib/api';
import { ActivityResponse } from '@troia-v3/types';

/**
 * Activities Service
 * Handles API calls for user pending activities (header dropdown)
 */
export const activitiesService = {
  /**
   * Get current user's pending activities (for header dropdown)
   * Returns activities the user needs to complete today or overdue
   */
  async getMyActivities(limit: number = 10): Promise<{ activities: ActivityResponse[]; total: number }> {
    const response = await api.get('/activities/my', { params: { limit } });
    return response.data.data;
  },
};
